import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { concat, first, Observable, switchMap } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DynamicTranslateService {

  constructor(private translate: TranslateService) { }

  public get(phrases: string[]): Observable<any> {
    return this.translate.get(phrases);
  }

  public getDynamicTranslations(phrases: string[]): Observable<any> {
    return concat(
      this.translate.get(phrases).pipe(first()),
      this.translate.onLangChange.pipe(
        switchMap(() => this.translate.get(phrases))
      )
    )
  }
}
